{
  "name": "@ns/authorise-subscription-card-use",
  "version": "1.0.0",
  "description": "Another company director's asking for your authorisation to use your card nodeStream for subscription payments",
  "inputs": {
    "caller": {
      "type": "string"
    },
    "subscriptionId": {
      "type": "string"
    },
    "paymentMethodId": {
      "type": "string"
    }
  },
  "outcomes": {
    "reject": {},
    "accept": {}
  }
}
